import { Component, OnInit, HostListener } from '@angular/core';
import { SmmPostService } from '../../../_services/smm-post.service';
import { GlobalService } from '../../../_services/global.service';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { ProjectsService } from 'app/_services/projects.service';
import { RouterProjectService } from 'app/_services/router-project.service';

import { DashboardService } from 'app/_services/dashboard.service';
import { SmmService } from 'app/_services/smm.service';
import { ToastrService } from 'ngx-toastr';
import { PostService } from 'app/_services/post.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ReportService } from '../../../_services/report.service';
import { CommentService } from 'app/_services/comment.service';
import { ActivatedRoute } from '@angular/router';
import { ProvinceService } from 'app/_services/province.service';
import { FieldsService } from 'app/_services/fields.service';
const moment = require('moment');

@Component({
  selector: 'app-dashboard1',
  templateUrl: './dashboard-detail.component.html',
  styleUrls: ['./dashboard-detail.component.scss']
})
export class DashboardDetailComponent implements OnInit {

  public daterange: any = {
    start: moment().startOf('day'),
    end: moment().endOf('day')
  };

  options: any = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  projectId = "";
  public isButtonLoading = false;
  public isButtonLoadingComment = false;
  public loading = true;
  sourceByTopic = "";
  isLoading = false;
  showError = false;
  errorMsg = '';
  currentComments = [];
  showErrorComment = false;
  isLoadingComment = false;
  errorMsgComment = '';
  modalRef: BsModalRef;
  public posts: Array<any> = [];
  public likePosts: Array<any> = [];
  public sharePosts: Array<any> = [];
  public commentsElastic: Array<any> = [];
  public pages: Map<string, any> = new Map<string, any>();
  public groups: Map<string, any> = new Map<string, any>();
  public resultCount: number;
  public resultCountComments: number;
  public currentPosts = [];
  public activePostId = null;
  public activeCommentId = null;
  public currentAccount;
  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  };
  dateInput = {
    start: new Date(),
    end: new Date()
  };
  public isRefresh: false;
  projectDropDownSettings = {
    singleSelection: true,
    text: 'Chọn chủ đề',
    enableSearchFilter: false
  };
  projectSelected = Array();
  projects = Array();
  filter = {};
  //nguon bai viet
  docTypeDropDownList = [
    { 'id': 1, 'itemName': 'Trang', value: '"page_post"' },
    { 'id': 2, 'itemName': 'Cá nhân', value: '"user_post"' },
    { 'id': 3, 'itemName': 'Nhóm', value: '"group_post"' },
    { 'id': 4, 'itemName': 'Báo chí', value: '"news_article"' },
    { 'id': 5, 'itemName': 'Blog', value: '"news_blog"' },
    { 'id': 6, 'itemName': 'Diễn đàn', value: '"news_forum"' },
    { 'id': 7, 'itemName': 'Youtube', value: '"youtube"' },
    { 'id': 8, 'itemName': 'Tiktok', value: '"tiktok"' }
  ];
  docTypeSelectedItems = [
    { 'id': 1, 'itemName': 'Trang', value: '"page_post"' },
    { 'id': 2, 'itemName': 'Cá nhân', value: '"user_post"' },
    { 'id': 3, 'itemName': 'Nhóm', value: '"group_post"' },
    { 'id': 4, 'itemName': 'Báo chí', value: '"news_article"' },
    { 'id': 5, 'itemName': 'Blog', value: '"news_blog"' },
    { 'id': 6, 'itemName': 'Diễn đàn', value: '"news_forum"' },
    { 'id': 7, 'itemName': 'Youtube', value: '"youtube"' },
    { 'id': 8, 'itemName': 'Tiktok', value: '"tiktok"' }
  ];
  docTypeDropDownSettings = {
    singleSelection: false,
    text: 'Nguồn bài viết',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2
  };
  //cam xuc
  sentimentDropDownList = [
    { 'id': 1, 'itemName': 'Tích cực', value: 'POS' },
    { 'id': 2, 'itemName': 'Trung tính', value: 'NEU' },
    { 'id': 3, 'itemName': 'Tiêu cực', value: 'NEG' }
  ];
  sentimentSelectedItems = [
    { 'id': 1, 'itemName': 'Tích cực', value: 'POS' },
    { 'id': 2, 'itemName': 'Trung tính', value: 'NEU' },
    { 'id': 3, 'itemName': 'Tiêu cực', value: 'NEG' }
  ];
  sentimentDropDownSettings = {
    singleSelection: false,
    text: 'Loại cảm xúc',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };
  //Thoi gian
  timeDropDownList = [
    { 'id': 1, 'itemName': 'Theo thời gian nội dung', value: 'createdDate' },
    { 'id': 2, 'itemName': 'Theo thời gian Crawl', value: 'collecttionDate' },
  ];
  timeSelectedItems = [
    { 'id': 1, 'itemName': 'Theo thời gian nội dung', value: 'createdDate' }
  ];
  timeDropDownSettings = {
    singleSelection: true,
    text: 'Thời gian',
    enableSearchFilter: false,
  };
  //lam moi
  timeRefreshDropDownList = [
    { 'id': 1, 'itemName': 'Không làm mới', value: '-1' },
    { 'id': 2, 'itemName': 'Làm mới sau 5s', value: '5' },
    { 'id': 3, 'itemName': 'Làm mới sau 10s', value: '10' },
    { 'id': 4, 'itemName': 'Làm mới sau 15s ', value: '15' },
    { 'id': 5, 'itemName': 'Làm mới sau 20s ', value: '20' },
  ];
  timeRefreshSelectedItems = [
    { 'id': 1, 'itemName': 'Không làm mới', value: '-1' }
  ];
  timeRefreshDropDownSettings = {
    singleSelection: true,
    text: 'Thời gian làm mới',
    enableSearchFilter: false,
  };
  //Loai bai viet
  isSpamDropDownList = [
    { 'id': 1, 'itemName': 'Tất cả', value: '-1' },
    { 'id': 2, 'itemName': 'Bài viết Spam', value: 'spam' },
    { 'id': 3, 'itemName': 'Bài viết không phải là Spam', value: 'notSpam' }
  ];
  isSpamSelectedItems = [
    { 'id': 1, 'itemName': 'Tất cả', value: '-1' }
  ];
  isSpamDropDownSettings = {
    singleSelection: true,
    text: 'Loại bài viết',
    enableSearchFilter: false,
  };
  // tinh thanh pho
  provinceDropDownList = [];
  provinceSelectedItems = [];
  provinceDropDownSettings = {
    singleSelection: false,
    text: 'Tỉnh / thành phố',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };
  //projectSelected
  project = "";
  public config1 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };

  //linh vuc
  fields = [];
  fieldsDropdownList = [];
  fieldsDropdownSelected = "-9999";
  small_fields = [];
  small_fieldsSelected = "-9999";

  constructor(
    private projectsService: ProjectsService,
    private dashboardService: DashboardService,
    private toastrService: ToastrService,
    private postService: PostService,
    private modalService: BsModalService,
    private reportService: ReportService,
    private smmPostService: SmmPostService,
    private commentService: CommentService,
    private activatedRoute: ActivatedRoute,
    private fieldsService: FieldsService,
    private provinceService: ProvinceService) {

  }

  //thanh dv loadmore scroll
  @HostListener('scroll', ['$event'])
  onScroll(event: any, type) {
    if (event.target.scrollTop != 0 && event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      if (type == "post" && !this.isButtonLoading) {
        if (this.resultCount > this.currentPosts.length) {
          this.isButtonLoading = true;
          this.loadMore();
        }
      }
      if (type == "comment" && !this.isButtonLoadingComment) {
        if (this.resultCountComments > this.currentComments.length) {
          this.isButtonLoadingComment = true;
          this.loadMoreComment();
        }
      }
    }
  }

  public loadMore() {
    this.isButtonLoading = true;
    this.search(this.posts.length, 10, this.posts, this.pages, this.groups);
  }

  public loadMoreComment() {
    this.isButtonLoadingComment = true;
    this.searchComments(this.currentComments.length, 10, this.commentsElastic);
  }

  ngOnInit(): void {
    this.getProject();
    this.getProvincesByUser();
    this.getFields();
    this.currentAccount = localStorage.getItem('currentSmmAccount') ?
      JSON.parse(localStorage.getItem('currentSmmAccount')) : {};

    setTimeout(() => {
      this.activatedRoute.queryParams.subscribe(params => {
        // let start=params['gte'];
        // let end=params['lte'];
        let sentiment = params['sentiment'];
        if (sentiment) {
          // console.log(sentiment.toUpperCase());
          for (var i = 0; i < this.sentimentDropDownList.length; i++) {
            if (sentiment.toUpperCase() == this.sentimentDropDownList[i].value) {
              this.sentimentSelectedItems = [];
              this.sentimentSelectedItems[0] = Object.assign({}, this.sentimentDropDownList[i]);
            }
          }
        }
        // if(start&&end){
        //   this.dateInput.start=new Date(parseInt(start));
        //   this.dateInput.end=new Date(parseInt(end));
        // }
        let projectId = params['projectId'];
        if (projectId) {
          for (var i = 0; i < this.projects.length; i++) {
            if (projectId == this.projects[i].id) {
              this.projectSelected[0] = Object.assign({}, this.projects[i]);
            }
          }
          if (this.projectSelected.length > 0) {
            this.clickBtn();
          }
        }
      });
    }, 800);
  }

  getFields() {
    this.fields = [];
    this.fieldsDropdownList = [];
    this.fieldsService.getAll().subscribe(response => {
      if (response.success) {
        this.fields = response.data.fields;
        for (var i = 0; i < this.fields.length; i++) {
          let obj = {
            id: this.fields[i]._id,
            name: this.fields[i].name
          };
          this.fieldsDropdownList.push(obj);
        }
      }
    });
  }
  changeFields(post) {
    post['_source']['small_fields'] = {};
    post['_source']['fields'].small_fields = [];
    if (post['_source']['fields']['id'] != "-9999") {
      for (var i = 0; i < this.fields.length; i++) {
        if (post['_source']['fields']['id'] == this.fields[i]._id) {
          post['_source']['fields'] = {
            id: this.fields[i]._id,
            name: this.fields[i].name,
            small_fields: Object.assign([], this.fields[i].small_fields)
          }
        }
      }
      if (post['_source']['fields'].small_fields.length == 0) {
        //update luon
        this.updateFieldsPost(post);
      }
    }
  }
  changeMainFields(post) {
    for (var i = 0; i < post['_source']['fields'].small_fields.length; i++) {
      if (post['_source']['fields'].small_fields[i]._id == post['_source']['small_fields'].id) {
        post['_source']['small_fields'] = {
          id: post['_source']['fields'].small_fields[i]._id,
          name: post['_source']['fields'].small_fields[i].name
        };
      }
    }
    this.updateFieldsPost(post);

  }

  updateFieldsPost(post) {
    post._source["_index"] = post._index;
    this.postService.updateFields(post._source).subscribe(response => {
      if (response.success) {
        this.toastrService.success('Đánh giá lĩnh vực bài viết thành công', 'Thông báo');
      } else {
        this.toastrService.error('Có lỗi xảy ra: response fail!', 'Lỗi');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra: err!', 'Lỗi');
      });
  }
  getProvincesByUser() {
    this.provinceService.getProvincesByUser({}).subscribe(response => {
      if (response.success) {
        response.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.provinceDropDownList.push(obj);
          // if (this.projectId == element._id) {
          //   this.projectSelected.push(obj);
          // }
        });
      }
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(obj);
        });
      }
    });
  }
  clickBtn() {
    //project
    let projectIds = [];
    if (this.projectSelected.length > 0) {
      for (var i = 0; i < this.projectSelected.length; i++) {
        projectIds.push(this.projectSelected[i].id);
        this.project = this.projectSelected[i].value;
      }
    } else {
      this.toastrService.warning("Bạn phải chọn chủ đề", "Thông báo");
      return;
    }
    //nguon bai viet
    let docTypes = [];
    if (this.docTypeSelectedItems.length > 0 && this.docTypeSelectedItems.length != this.docTypeDropDownList.length) {
      for (var i = 0; i < this.docTypeSelectedItems.length; i++) {
        docTypes.push(this.docTypeSelectedItems[i].value);
      }
    }
    //sentiment
    let sentiment = [];
    if (this.sentimentSelectedItems.length > 0 && this.sentimentSelectedItems.length != this.sentimentDropDownList.length) {
      for (var i = 0; i < this.sentimentSelectedItems.length; i++) {
        sentiment.push(this.sentimentSelectedItems[i].value);
      }
    }
    //typeTime
    let typeTime = this.timeSelectedItems[0].value;
    //provinces
    let provinces = [];
    if (this.provinceSelectedItems.length == 0) {
      if (!this.currentAccount.admin) {
        for (var i = 0; i < this.provinceDropDownList.length; i++) {
          provinces.push(this.provinceDropDownList[i].value);
        }
      }
    } else {
      for (var i = 0; i < this.provinceSelectedItems.length; i++) {
        provinces.push(this.provinceSelectedItems[i].value);
      }
    }
    if (!this.currentAccount.admin && provinces.length == 0) {
      this.toastrService.error("Bạn chưa được phân vùng tỉnh / thành phố!", "Thông báo");
      return;
    }
    //typeOrder
    let typeOrderPost = $("#orderPost").val();
    let typeOrderComment = $("#orderComment").val();
    this.filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projectIds: projectIds,
      docTypes: docTypes,
      sentiment: sentiment,
      typeTime: typeTime,
      typeOrderPost: typeOrderPost,
      typeOrderComment: typeOrderComment,
      provinces: provinces,
      sourceByTopic: this.sourceByTopic,
    };
    this.posts = [];
    this.currentPosts = [];
    this.commentsElastic = [];
    this.search(0, 10, this.posts, this.pages, this.groups);
    this.searchComments(0, 10, this.commentsElastic);
    //lam moi du lieu
    let refresh = parseInt(this.timeRefreshSelectedItems[0].value);
    if (refresh > 0) {
      let time = refresh * 1000 + 2000;
      setTimeout(() => {
        this.clickBtn();
      }, time);
    }
  }

  public changeCurrentPosts() {
    if (this.posts.length === 0) {
      this.search(0, 10, this.posts, this.pages, this.groups);
    }
    this.currentPosts = this.posts;
    // console.log(this.posts);
  }

  search(from, size, posts, pages, groups) {
    this.isLoading = true;
    this.dashboardService.searchDashboard({ from: from, size: size, filter: this.filter, type: "post" }).subscribe(response => {
      this.showError = false;
      if (response.success) {
        if (response.data.hits.total.value > 0) {
          const pageIdArray = [];
          const groupIdArray = [];
          const userIdArray = [];
          for (const post of response.data.hits.hits) {
            post.showContent = false;
            //thanhdv
            if (!post['_source']['fields']) {
              post['_source']['fields'] = {
                id: "-9999",
                name: "-9999",
                small_fields: []
              };
            }
            if (!post['_source']['small_fields']) {
              post['_source']['small_fields'] = {
              };
            }


            post['_source']['message'] = (post['_source']['content']) ? post['_source']['content'] : post['_source']['message'];
            post['_source']['sentiment'] = "";
            post['_source']['sentimentCode'] = "";
            let sentimentArray = [];
            if (post['_source']['topicSentiment'] !== undefined) {
              sentimentArray = post['_source']['topicSentiment'];
              for (let index = 0; index < sentimentArray.length; index++) {
                const element = sentimentArray[index];
                if (element.id == this.filter['projectIds'][0]) {
                  let sentiment = element.sentiment;
                  if (sentiment == 'neu') {
                    post['_source']['sentiment'] = "Trung tính";
                    post['_source']['sentimentCode'] = "neu";
                  } else if (sentiment == 'pos') {
                    post['_source']['sentiment'] = "Tích cực";
                    post['_source']['sentimentCode'] = "pos";
                  } else if (sentiment == 'neg') {
                    post['_source']['sentiment'] = "Tiêu cực";
                    post['_source']['sentimentCode'] = "neg";
                  }
                  break;
                }
              }
            }
            // TMHIEP - 14/05/2020 - END

            // TMHIEP - 12/08/2020 - START
            post['_source']['docTypeName'] = "";
            if (post['_source']['docType'] == "news_article") {
              post['_source']['docTypeName'] = "Báo chí";
            } else if (post['_source']['docType'] == "news_blog") {
              post['_source']['docTypeName'] = "Blog";
            } else if (post['_source']['docType'] == "news_forum") {
              post['_source']['docTypeName'] = "Forum";
            }
            // TMHIEP - 12/08/2020 - END

            posts.push(post);

          }
          setTimeout(() => {
            this.isButtonLoading = false;
          }, 1000);
          this.resultCount = response.data.hits.total.value;
          this.showError = false;
          this.isLoading = false;
          this.errorMsg = "";
          this.changeCurrentPosts();
        } else {
          this.showError = true;
          this.isLoading = false;
          this.errorMsg = 'Không tìm thấy dữ liệu!';
        }
      } else {
        this.showError = true;
        this.isLoading = false;
        this.errorMsg = 'Có lỗi xảy ra! Không tìm thấy dữ liệu!';
        // this.searchBody.nativeElement.classList.remove('show');
      }
    });
  }

  public searchComments(from, size, comments) {
    this.isLoadingComment = true;
    this.dashboardService.searchDashboardComment({
      from: from, size: size,
      filter: this.filter,
      type: "comment"
    }).subscribe(response => {
      this.showErrorComment = false;
      this.isLoadingComment = false;
      this.errorMsgComment = '';
      if (response.success) {
        if (response.data.hits.total.value > 0) {
          for (const comment of response.data.hits.hits) {
            comment.showContent = false;

            // TMHIEP - 14/05/2020 - START
            comment['_source']['sentiment'] = "";
            comment['_source']['sentimentCode'] = "";
            let sentimentArray = [];
            if (comment['_source']['topicSentiment'] !== undefined) {
              sentimentArray = comment['_source']['topicSentiment'];
              for (let index = 0; index < sentimentArray.length; index++) {
                const element = sentimentArray[index];
                if (element.id == this.filter['projectIds'][0]) {
                  let sentiment = element.sentiment;
                  if (sentiment == 'neu') {
                    comment['_source']['sentiment'] = "Trung tính";
                    comment['_source']['sentimentCode'] = "neu";
                  } else if (sentiment == 'pos') {
                    comment['_source']['sentiment'] = "Tích cực";
                    comment['_source']['sentimentCode'] = "pos";
                  } else if (sentiment == 'neg') {
                    comment['_source']['sentiment'] = "Tiêu cực";
                    comment['_source']['sentimentCode'] = "neg";
                  }
                  break;
                }
              }
            }
            // TMHIEP - 14/05/2020 - END

            comments.push(comment);
          }
          this.currentComments = comments;
          console.log(comments);
          this.resultCountComments = response.data.hits.total.value;
          // this.searchBody.nativeElement.classList.remove('show');
          this.isButtonLoadingComment = false;
        } else {
          this.currentComments = [];
          this.showErrorComment = true;
          this.isLoadingComment = false;
          this.errorMsgComment = 'Không tìm thấy dữ liệu!';
        }
      } else {
        this.currentComments = [];
        this.showErrorComment = true;
        this.isLoadingComment = false;
        this.errorMsgComment = 'Không tìm thấy dữ liệu!';
        // this.searchBody.nativeElement.classList.remove('show');
      }
    }
    );
  }

  exportConfirm(template) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  public showFullPost(index) {
    this.currentPosts[index].showContent = !this.currentPosts[index].showContent;
  }

  public showFullComment(index) {
    this.currentComments[index].showContent = !this.currentComments[index].showContent;
  }

  public clickPostItem(event, post) {
    this.activePostId = post._id;
    console.log(this.activePostId);
  }

  public clickCommentItem(comment) {
    this.activeCommentId = comment._id;
  }

  public showPostContent(postSource, callback = undefined) {

    //get comment --thanhdv
    // console.log(postSource);
    this.smmPostService.findPostByIdAndIndex(postSource.docId, postSource._index, {}
    ).subscribe(response => {
      if (response.success) {
        if (response.data._source.comments) {
          postSource.comments = response.data._source.comments;
        }
      }


      if (callback) callback();
    });

  }
  changeSentiment(post) {
    console.log(post);
    let id = post._source.docId;
    let sentiment = $("#" + id).val();
    for (let index = 0; index < post._source.topicSentiment.length; index++) {
      if (post._source.topicSentiment[index].id == this.filter["projectIds"][0]) {
        post._source.topicSentiment[index].sentiment = sentiment;
        let userName = localStorage.getItem('currentSmmAccount') !== undefined && localStorage.getItem('currentSmmAccount') !== 'undefined' ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
        post._source.topicSentiment[index].actorId = userName["userName"];
        break;
      }
    }
    post._source["_index"] = post._index;
    //add bai viet
    this.showPostContent(post._source, () => {
      if (!post._source.isRead) {

        let accountSSL = localStorage.getItem('currentSmmAccount') !== null ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
        post._source['accountSSL'] = accountSSL;
        post._source['project'] = {
          projectName: this.projectSelected[0].value,
          projectId: this.projectSelected[0].id
        }

        this.postService.create(post);
      }
      setTimeout(() => {
        // UPDATE DB
        post._source.project = {
          projectName: this.projectSelected[0].value,
          projectId: this.projectSelected[0].id
        }
        this.postService.updatePostSentiment(post._source).subscribe(response => {
          if (response.success) {
            this.toastrService.success('Đánh giá cảm xúc bài viết thành công', 'Thông báo');
          } else {
            this.toastrService.error('Có lỗi xảy ra: response fail!', 'Lỗi');
          }
        },
          err => {
            this.toastrService.error('Có lỗi xảy ra: err!', 'Lỗi');
          });
      }, 200);
    });
  }
  changeSentimentComment(comment) {
    comment._source['project'] = {
      projectName: this.projectSelected[0].value,
      projectId: this.projectSelected[0].id
    };
    this.commentService.addNew(comment);

    // GỌI API
    this.smmPostService.findPostByIdAndIndex(comment._source.postId, comment._source.postIndex, {}
    ).subscribe(response => {
      this.showError = false;
      if (response.success) {
        if (response.data._source !== undefined) {
          // CHI TIẾT POST
          let accountSSL = localStorage.getItem('currentSmmAccount') !== null ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
          let post = response.data._source;
          post["_index"] = response.data._index;
          if (!response.data._source.isRead) {
            response.data._source._index = response.data._index;
            response.data._source.docIndex = response.data._index;
            response.data._source['project'] = {
              projectName: this.projectSelected[0].value,
              projectId: this.projectSelected[0].id
            }
            this.postService.create(response.data);
          };
          // BUILD LẠI COMMENT
          let id = comment._source.docId;
          let sentiment = $("#" + id).val();
          for (let index = 0; index < comment._source.topicSentiment.length; index++) {
            if (comment._source.topicSentiment[index].id == this.projectSelected[0].id) {
              comment._source.topicSentiment[index].sentiment = sentiment;
              comment._source.topicSentiment[index].actorId = accountSSL.username;
              break;
            }
          }

          // THÔNG TIN POST (COMMENT TRONG POST)
          comment._source.postId = post.docId;
          comment._source.postIndex = post["_index"];
          for (var i = 0; i < post.comments.length; i++) {
            if (post.comments[i].docId == comment._id) {
              post.comments[i] = comment._source;
            }
          }
          // UPDATE DB
          setTimeout(() => {
            this.postService.updateCommentInPostSentiment(post).subscribe(response => {
              if (response.success) {
                /* --------------------------- BÌNH LUẬN - START ------------------------*/
                this.commentService.updateCommentSentiment(comment._source).subscribe(response => {
                  if (response.success) {
                    this.toastrService.success('Đánh giá cảm xúc bình luận thành công', 'Thông báo');
                  } else {
                    this.toastrService.error('Đánh giá cảm xúc bình luận không thành công', 'Lỗi');
                  }
                },
                  err => {
                    this.toastrService.error('Xảy ra lỗi gọi api!', 'Lỗi');
                  });
                /* --------------------------- BÌNH LUẬN - END --------------------------*/
              } else {
                this.toastrService.error('Có lỗi xảy ra: response fail!', 'Lỗi');
              }
            },
              () => {
                this.toastrService.error('Có lỗi xảy ra: err!', 'Lỗi');
              });
          }, 200);
        } else {
          this.toastrService.error("Có lỗi xảy ra, không tìm thấy bài viết!", "Thông báo");
        }
      } else {
        this.toastrService.error("Có lỗi xảy ra, không tìm thấy bài viết!", "Thông báo");
      }
    }
    );

  }
  exportData(type) {
    if (type == 'post') {
      if (this.currentPosts.length == 0) {
        this.toastrService.error("Không có dữ liệu để xuất báo cáo!", "Thông báo!");
      } else {
        this.dashboardService.searchDashboard({ from: 0, size: 10000, filter: this.filter, type: "post" }).subscribe(response => {
          if (response.success) {
            let data = [];
            if (response.data.hits.total.value > 0) {
              this.toastrService.success("Đang xuất báo cáo, chờ trong giây lát!", "Thông báo");
              for (const post of response.data.hits.hits) {
                post['_source']['sentiment'] = "";
                let sentimentArray = [];
                if (post['_source']['topicSentiment'] !== undefined) {
                  sentimentArray = post['_source']['topicSentiment'];
                  for (let index = 0; index < sentimentArray.length; index++) {
                    const element = sentimentArray[index];
                    if (element.id == this.filter['projectIds'][0]) {
                      let sentiment = element.sentiment;
                      if (sentiment == 'neu') {
                        post['_source']['sentiment'] = "Trung tính";
                      } else if (sentiment == 'pos') {
                        post['_source']['sentiment'] = "Tích cực";
                      } else if (sentiment == 'neg') {
                        post['_source']['sentiment'] = "Tiêu cực";
                      }
                      break;
                    }
                  }
                }
                let obj = {
                  createDate: moment(post['_source'].createDate).format('DD/MM/YYYY h:mm:ss a'),
                  timeCrawl: (post['_source'].collectDate) ? moment(post['_source'].collectDate).format('DD/MM/YYYY h:mm:ss a') : "",
                  content: post['_source']['content'] ||post['_source']['title'] || post['_source']['message'].substring(0, 300)  ,
                  numLikes: (post['_source']["numLikes"]) ? post['_source']["numLikes"] : "",
                  numComments: (post['_source']["numComments"]) ? post['_source']["numComments"] : "",
                  source: post['_source']["sourceName"],
                  sentiment: post['_source']['sentiment']
                };
                data.push(obj);
              }
            }

            let headerDetailContentReport1 = [{ start: 1 }, { name: "STT", rowspan: 2 }, { name: "Ngày đăng", rowspan: 2 }, { name: "Thời gian về hệ thống", rowspan: 2 }, { name: "Tóm tắt", rowspan: 2 }, { name: "Số lượng phản ánh", colspan: 2 }, { name: "Nguồn thông tin", rowspan: 2 }, { name: "Sắc thái", rowspan: 2 }];
            let headerDetailContentReport2 = [{ start: 5 }, { name: "Like" }, { name: "Bình luận" }];
            let objDetailContentReport = { name: "Báo cáo chi tiết bài viết", header: [headerDetailContentReport1, headerDetailContentReport2], data: data };
            let dataExport = Array();
            dataExport.push(objDetailContentReport);
            this.reportService.exportReportToExcel(dataExport);
            setTimeout(() => {
              this.modalRef.hide();
            }, 2000);

          } else {
            this.toastrService.error("Có lỗi xảy ra", "Thông báo");
          }
        });
      }
    } else {
      if (this.currentComments.length == 0) {
        this.toastrService.error("Không có dữ liệu để xuất báo cáo!", "Thông báo!");
      } else {
        this.dashboardService.searchDashboardComment({ from: 0, size: 10000, filter: this.filter, type: "comment" }).subscribe(response => {
          if (response.success) {
            let data = [];
            if (response.data.hits.total.value > 0) {
              this.toastrService.success("Đang xuất báo cáo, chờ trong giây lát!", "Thông báo");
              for (const comment of response.data.hits.hits) {
                comment['_source']['sentiment'] = "";
                let sentimentArray = [];
                if (comment['_source']['topicSentiment'] !== undefined) {
                  sentimentArray = comment['_source']['topicSentiment'];
                  for (let index = 0; index < sentimentArray.length; index++) {
                    const element = sentimentArray[index];
                    if (element.id == this.filter['projectIds'][0]) {
                      let sentiment = element.sentiment;
                      if (sentiment == 'neu') {
                        comment['_source']['sentiment'] = "Trung tính";
                      } else if (sentiment == 'pos') {
                        comment['_source']['sentiment'] = "Tích cực";
                      } else if (sentiment == 'neg') {
                        comment['_source']['sentiment'] = "Tiêu cực";
                      }
                      break;
                    }
                  }
                }
                let obj = {
                  createDate: moment(comment['_source'].createDate).format('DD/MM/YYYY h:mm:ss a'),
                  timeCrawl: (comment['_source'].collectDate) ? moment(comment['_source'].collectDate).format('DD/MM/YYYY h:mm:ss a') : "",
                  content: ((comment['_source']['content']) ? comment['_source']['content'] : comment['_source']['message']).substring(0, 300),
                  numLikes: (comment['_source']["numLikes"]) ? comment['_source']["numLikes"] : "",
                  numComments: (comment['_source']["numReactions"]) ? comment['_source']["numReactions"] : "",
                  source: comment['_source']["name"],
                  sentiment: comment['_source']['sentiment']
                };
                data.push(obj);
              }
            }
            console.log(data);
            let headerDetailContentReport1 = [{ start: 1 }, { name: "STT", rowspan: 2 }, { name: "Ngày đăng", rowspan: 2 }, { name: "Thời gian về hệ thống", rowspan: 2 }, { name: "Tóm tắt", rowspan: 2 }, { name: "Số lượng phản ánh", colspan: 2 }, { name: "Nguồn thông tin", rowspan: 2 }, { name: "Sắc thái", rowspan: 2 }];
            let headerDetailContentReport2 = [{ start: 5 }, { name: "Like" }, { name: "Trả lời" }];
            let objDetailContentReport = { name: "Báo cáo chi tiết bình luận", header: [headerDetailContentReport1, headerDetailContentReport2], data: data };
            let dataExport = Array();
            dataExport.push(objDetailContentReport);
            this.reportService.exportReportToExcel(dataExport);
            setTimeout(() => {
              this.modalRef.hide();
            }, 2000);

          } else {
            this.toastrService.error("Có lỗi xảy ra", "Thông báo");
          }
        });
      }
    }
  }
  changeOderPost() {
    let typeOrder = $("#orderPost").val();
    if (this.currentPosts.length > 0) {
      this.filter["typeOrderPost"] = typeOrder;
      this.posts = [];
      this.search(0, 10, this.posts, this.pages, this.groups);
    }
  }
  changeOderComment() {
    let typeOrder = $("#orderComment").val();
    if (this.currentPosts.length > 0) {
      this.filter["typeOrderComment"] = typeOrder;
      this.currentComments = [];
      this.searchComments(0, 10, this.currentComments);
    }
  }
  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard-detail/dashboard-detail.component.ts